import {
  SetFavoriteItemResponse,
  SetFavoriteItemListResponse,
  SetFavoriteItemRequest
} from '../../../models/api/front/favorite-set'
import { ApiBaseFront } from '../api-base-front'


// お気に入り商品のセット一覧取得
export class ApiSetFavoriteListGet extends ApiBaseFront<SetFavoriteItemListResponse> {
  constructor(param: { kijshopCd: string }) {
    super(
      'GET',
      `/api/v1/setFavorite`,
      'JSON',
      param,
    );
  }
};

// お気に入り商品のセット1件取得
export class ApiSetFavoriteGet extends ApiBaseFront<SetFavoriteItemResponse> {
  constructor(id: string, param: { kijshopCd: string }) {
    super(
      'GET',
      `/api/v1/setFavorite/${id}`,
      'JSON',
      param,
    );
  }
};

// お気に入り商品のセット登録
export class ApiSetFavoriteCreate extends ApiBaseFront<SetFavoriteItemResponse> {
  constructor(param: { kijshopCd: string; name: string; favProductIds: string[] }) {
    super(
      'POST',
      `/api/v1/setFavorite`,
      'JSON',
      param,
    );
  }
};

// お気に入り商品のセット編集
export class ApiSetFavoriteUpdate extends ApiBaseFront<SetFavoriteItemResponse> {
  constructor(id: string, param: { kijshopCd: string; name: string; favProductIds: string[] }) {
    super(
      'POST',
      `/api/v1/setFavorite/${id}`,
      'JSON',
      param,
    );
  }
};

// お気に入り商品のセット削除
export class ApiSetFavoriteDelete extends ApiBaseFront<void> {
  constructor(id: string, param: { kijshopCd: string }) {
    super(
      'DELETE',
      `/api/v1/setFavorite/${id}`,
      'JSON',
      param,
    );
  }
};

